import { motion } from "framer-motion";
import { BookOpen, MessageCircle, Shield, FileText } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";
import { useEffect, useState } from "react";
import versionContent from "@/content/version.md?raw";

const InfoBar = () => {
  const { t } = useI18n();
  const version = versionContent.trim();

  const infoItems = [
    { icon: BookOpen, label: t('info.guide') },
    { icon: MessageCircle, label: t('info.feedback') },
    { icon: Shield, label: t('info.privacy') },
    { icon: FileText, label: t('info.terms') },
  ];

  const handleClick = (label: string) => {
    toast.info(t('common.coming_soon'));
  };

  return (
    <motion.footer
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, delay: 0.55 }}
      className="glass-bar rounded-xl px-4 py-2 flex items-center justify-center gap-4 relative"
    >
      <div className="flex items-center justify-center gap-4">
        {infoItems.map(({ icon: Icon, label }) => (
          <button
            key={label}
            onClick={() => handleClick(label)}
            className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon className="w-3 h-3" />
            <span>{label}</span>
          </button>
        ))}
      </div>

      {version && (
        <div className="absolute right-4 text-[10px] font-bold text-muted-foreground/60 select-none">
          {version}
        </div>
      )}
    </motion.footer>
  );
};

export default InfoBar;
